import { createSlice } from "@reduxjs/toolkit";
import AdminApi from "../../api/AdminApi";

type State = {
	data: Object,
	isLoading: boolean,
	error: Object | null
}

// Slice
const slice = createSlice({
	name: "authenticateuser",
	initialState: {
		data: {},
		isLoading: true,
		error: null,
	},
	reducers: {
		authenticateUserStart: (state: State) => {
			state.isLoading = true;
		},
		authenticateUserSuccess: (state: State, action) => {
			state.isLoading = false;
			state.data = action.payload;
		},
		authenticateUserFailed: (state: State, action) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export default slice.reducer;

// Actions
const {
	authenticateUserStart,
	authenticateUserSuccess,
	authenticateUserFailed
} = slice.actions;

export const authenticateUser = () => async (dispatch: Function) => {
	try {
		dispatch(authenticateUserStart());
		const api = new AdminApi();
		const result = await api.authenticateUser();
		dispatch(authenticateUserSuccess(result));
	} catch (err: any) {
		dispatch(authenticateUserFailed(err));
	}
};
